function enableFontSelection(){
    const group = document.querySelector('.font-picker');
    const options = Array.from(group.querySelectorAll('.font-option'));

    function setActive(next){
        options.forEach(el => {
            const active = el === next;
            el.setAttribute('aria-checked', active ? 'true' : 'false');
            el.tabIndex = active ? 0 : -1;
        });
    }

    options.forEach(el => {
        el.addEventListener('click', () => setActive(el));
        el.addEventListener('keydown', (e) => {
            if(e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                setActive(el);
            }
        });
    });

    group.addEventListener('keydown', (e) => {
        const current = document.activeElement.closest('.font-option');
        if(!current) return;
        const idx = options.indexOf(current);
        if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){
            e.preventDefault();
            const next = options[(idx + 1) % options.length];
            next.focus(); setActive(next);
        } else if(e.key === 'ArrowLeft' || e.key === 'ArrowUp'){
            e.preventDefault();
            const prev = options[(idx - 1 + options.length) % options.length];
            prev.focus(); setActive(prev);
        }
    });
};

enableFontSelection()

window.addEventListener('pdp_variant_change', (e) => {
    enableFontSelection()
});